import React from 'react';
import { Card, CardHeader, CardContent } from "@/components/ui/card";

export const BugReportCardSkeleton: React.FC = () => {
  return (
    <Card className="animate-pulse">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-start gap-2 flex-1">
            <div className="w-5 h-5 bg-neutral-200 rounded shrink-0"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-neutral-200 rounded w-3/4"></div>
              <div className="h-3 bg-neutral-200 rounded w-1/2"></div>
            </div>
          </div>
          <div className="flex gap-0.5">
            <div className="w-3 h-3 bg-neutral-200 rounded-full"></div>
            <div className="w-3 h-3 bg-neutral-200 rounded-full"></div>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="h-5 bg-neutral-200 rounded w-16"></div>
          <div className="h-3 bg-neutral-200 rounded w-12"></div>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="space-y-2">
          <div className="h-3 bg-neutral-200 rounded w-full"></div>
          <div className="h-3 bg-neutral-200 rounded w-5/6"></div>
          <div className="h-3 bg-neutral-200 rounded w-4/6"></div>
        </div>

        <div className="flex gap-1">
          <div className="h-5 bg-neutral-200 rounded w-12"></div>
          <div className="h-5 bg-neutral-200 rounded w-16"></div>
        </div>

        <div className="flex items-center justify-between pt-2 border-t">
          <div className="flex items-center gap-2">
            <div className="h-3 bg-neutral-200 rounded w-20"></div>
            <div className="h-3 bg-neutral-200 rounded w-20"></div>
          </div>
          <div className="h-3 bg-neutral-200 rounded w-8"></div>
        </div>

        <div className="h-3 bg-neutral-200 rounded w-24"></div>
      </CardContent>
    </Card>
  );
};
